import { httpRequest } from "../../utils/httpRequest";

export function listMedia(token, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return httpRequest("GET", `/media${qs ? `?${qs}` : ""}`, {}, { "x-access-token": token });
}

export function uploadMedia(token, formData) {
  // توجه: httpRequest به طور پیش‌فرض content-type: application/json ست می‌کند.
  // برای FormData باید multipart باشد:
  return httpRequest("POST", "/media", formData, {
    "x-access-token": token,
    "content-type": "multipart/form-data",
  });
}

export function deleteMedia(token, id) {
  return httpRequest("DELETE", `/media/${id}`, {}, { "x-access-token": token });
}